<template>
  <div id="administration">
    <el-card shadow="never">
      <div>
        <el-row :gutter="50">
          <el-col :span="20">
            <div>
              <el-form
                :label-position="labelPosition"
                label-width="100px"
                :model="queryInfo"
                size="small"
                :inline="true"
              >
                <el-form-item label="分组名称">
                  <el-input v-model="queryInfo.custGrpName"></el-input>
                </el-form-item>
                <el-form-item label="分组类型">
                  <el-select v-model="queryInfo.grpKind">
                    <el-option value="0" label="公共分组"></el-option>
                    <el-option value="1" label="个人分组"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="创建日期从">
                  <el-date-picker
                    v-model="dateValue"
                    type="daterange"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions"
                  ></el-date-picker>
                </el-form-item>
              </el-form>
            </div>
          </el-col>

          <el-col :span="4">
            <div class="header-button">
              <el-button icon="el-icon-search" plain @click="searchBtn"
                >查询</el-button
              >
            </div>
          </el-col>
        </el-row>
      </div>
    </el-card>

    <div>
      <el-table
        size="small"
        class="table-style"
        height="280px"
        border
        :row-class-name="tableRowClassName"
        :header-cell-style="{
          background: '#FCFBF2',
          color: '#6C6839',
          'text-align': 'center',
        }"
        :cell-style="{ 'text-align': 'center' }"
        ref="CategoryTable1"
        :data="tableData"
        tooltip-effect="dark"
        v-el-table-infinite-scroll="load"
        v-loading="loading"
        infinite-scroll-disabled="onLoading"
      >
        <el-table-column type="index" width="55"></el-table-column>
        <el-table-column label width="30">
          <template slot-scope="scope">
            <el-radio
              :label="scope.$index"
              v-model="radioxz"
              @change.native="getCurrentRow(scope.row)"
              >&nbsp;</el-radio
            >
          </template>
        </el-table-column>
        <el-table-column label="分组名称" prop="custGrpName"></el-table-column>
        <el-table-column label="分组类型" prop="grpKind">
          <template slot-scope="scope">
            {{ scope.row.grpKind == 0 ? "公共分组" : "个人分组" }}
          </template>
        </el-table-column>
      </el-table>
      <el-alert
        v-if="total <= tableData.length"
        title="没有更多数据了!"
        type="warning"
        center
        :closable="false"
      ></el-alert>
    </div>

    <div style="margin-top: 20px; float: right">
      <el-button @click="submit()">确定</el-button>
      <el-button @click="close()">取消</el-button>
    </div>
    <div style="clear: both"></div>
  </div>
</template>

<script>
import { selectProduct } from "@/api/friends";
import { groundPageApi1 } from "@/api/marketing";
export default {
  name: "centre",

  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      dateValue: [],
      loading: false,
      // 选择会员radio
      radioxz: "",
      labelPosition: "right",
      searchForm: {
        pageNo: 1,
        pageSize: 20,
        search: "",
        company: "",
        state: "",
        startDay: "",
        endDay: "",
      },

      queryInfo: {
        pageNo: 1,
        pageSize: 20,
        cpyNO: 6100,
        createDateStart: "",
        createDateEnd: "",
        grpKind: "",
        state: 0,
        custGrpName: "",
      },
      pageNum: 0,
      pageSize: 0,
      tableData: [], //列表数据
      templatei: {}, //选中数据
      size: 0,
      total: 0,
      loading: false,
    };
  },
  created() {
    this.loading = true;
    this.tableList();
  },
  computed: {
    onLoading() {
      console.log(this.total, this.tableData.length);
      return this.loading || this.total < this.tableData.length;
    },
  },
  methods: {
    load() {
      setTimeout(() => {
        if (this.total > this.tableData.length) {
          this.queryInfo.pageNo += 1;
          this.loading = true;
          this.tableList();
        }
      }, 1000);
    },
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
    currentChange(row) {
      this.queryInfo.pageNo = row;
      this.tableList();
    },
    //确定
    submit() {
      if (this.templatei.customerGrpID) {
        this.$emit("submit", this.templatei);
      } else {
        this.$message.error("请先选中一行数据");
      }
    },
    //取消
    close() {
      console.log("触发1");
      this.$emit("close");
    },
    getCurrentRow(row) {
      // 获取选中数据   row表示选中这一行的数据，可以从里面提取所需要的值
      this.templatei = row;
      console.log(this.templatei);
    },
    //table表格数据
    async tableList() {
      await groundPageApi1(this.queryInfo).then((res) => {
        console.log(res);
        this.loading = false;
        this.tableData = this.tableData.concat(res.data.list);
        this.total = res.data.total;
        this.size = res.data.size;
        this.pageSize = res.data.pageSize;
      });
    },
    // 搜索
    searchBtn() {
      if (this.dateValue && this.dateValue.length > 0) {
        this.queryInfo.createDateStart = this.renderTime(
          this.dateValue[0]
        ).substring(0, 10);
        this.queryInfo.createDateEnd = this.renderTime(
          this.dateValue[1]
        ).substring(0, 10);
      } else {
        this.queryInfo.createDateStart = "";
        this.queryInfo.createDateEnd = "";
      }
      this.queryInfo.pageNo = 1;
      this.tableData = [];
      this.loading = true;
      this.tableList();
    },
    renderTime(date) {
      //格式化时间
      if (date != null) {
        var dateee = new Date(date).toJSON();
        return new Date(+new Date(dateee) + 8 * 3600 * 1000)
          .toISOString()
          .replace(/T/g, " ")
          .replace(/\.[\d]{3}Z/, "");
      } else {
        return "";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
#administration {
  // height: 1400px;
  height: 100%;
}
.header {
  .header-text {
    width: 200px;
    height: 50px;
    margin-top: 20px;
    color: #76734f;
  }
  .card-pagination {
    height: 50px;
  }
}
// 按钮边框去掉，文字颜色和加粗
/deep/button {
  border-color: #e6e0af;
  border-radius: 7px;
  color: #a19b59;
}

// input框的背景色和取消圆角

/deep/input {
  border-radius: 0;
}
// 去除表头复选框
/deep/.table-style {
  .el-table-column--selection.is-leaf .el-checkbox {
    display: none;
  }
}

::v-deep {
  // 改变table里的按钮图标大小
  .table-button .iconfont {
    font-size: 14px;
  }
  .el-table .warning-row {
    background: #fcfbf2;
  }

  .el-table .success-row {
    background: #ffffff;
  }
  // 改变分页背景色
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #d1cda5 !important;
    color: #ffffff !important;
  }
  // 改变分页字体颜色
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    color: #d1cda5 !important;
  }
  .el-tabs__item {
    width: 42%;
    font-size: 12px !important;
  }
  // 设置表单里字体的颜色
  .el-form-item__label {
    color: #76734f;
  }
  .unfreeze {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__body {
      padding: 0 50px 30px 50px;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }
    .el-button:hover {
      background-color: #b5b386;
      color: #f2f2f2 !important;
    }
    .el-form-item__content {
      line-height: 0px;
    }
  }
  .bound {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__body {
      padding: 0 50px 30px 50px;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }
    .el-button:hover {
      background-color: #b5b386;
      color: #6e6e6e !important;
    }
    .el-form-item__content {
      line-height: 0px;
    }
  }
  // 删除弹框样式
  .delete {
    .el-dialog__header,
    .el-message-box__header {
      border-top-left-radius: 9px;
      border-top-right-radius: 9px;
      height: 44px;
      background: #f3f1dd;
      width: 100%;
      text-align: center;
      color: #666;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      box-sizing: border-box;
    }
    .el-dialog__title,
    .el-message-box__title {
      color: #6c6937;
      font-weight: 700;
      font-size: 16px !important;
    }
    .el-dialog .el-dialog__body {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .coverage-release .el-dialog__body {
      padding: 20px;
    }
    .el-button:hover {
      background-color: #b6b388;
    }
    .el-dialog__body {
      padding: 30px 60px;
    }
    .el-tabs__item {
      border: 1px solid #d9d9d9;
      background-color: #fff;
      color: #6c6937;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }

    .el-tabs__item.is-active {
      color: #6c6937;
      background-color: #f3f1dd;
    }
    .el-form-item__content {
      line-height: 0px;
    }
    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }
}
</style>
